import React,{Component} from "react";
import {citationFetchData} from "../../../actions/citation";
import {connect} from "react-redux";

class CitationInformation extends Component{

    componentDidMount() {
        this.props.fetchData(`https://psytable-api.herokuapp.com/api/citation/${this.props.category}/${this.props.citationId}`);
    }


    render() {
        return (
            <section className="information">
                <div className="information__inner">
                    <div className="information__table">
                        <div className="information__left">
                            <div className="total-score">
                            <span className="total-score__text">
                                EPA Total Score:
                            </span>
                                <span className="total-score__quantity">
                                40/100
                            </span>
                            </div>
                            <div className="support-score">
                            <span className="support-score__text">
                                Support score:
                            </span>
                                <span className="support-score__quantity">
                                60
                            </span>
                            </div>
                            <div className="challenge-score">
                            <span className="challenge-score__text">
                                Challenge score:
                            </span>
                                <span className="challenge-score__quantity">
                                5
                            </span>
                            </div>
                            <div className="submitted-by">
                            <span className="submitted-by__text">
                                Submitted by:
                            </span>
                                <span className="submitted-by__quantity">
                                djglass
                            </span>
                            </div>
                        </div>

                        {
                            this.props.citation.map((item, index) => {
                                return(

                                    <div className="information__right" key={index}>
                                        <p className="information__author information__tagline">{item.authorName}. {item.articleName} {item.cityOrPublisher}</p>
                                                                            <p className="information__disgust information__tagline">A perspective on disgust.</p>
                                        <p className="information__review information__tagline">Psychological Review, {item.pageNumber}</p>

                                        <div className="url">
                                            <span className="url__text">Url:</span>
                                            <a  href={item.url} className="url__link">{item.url}</a>
                                        </div>
                                        <div className="abstract">
                                            <span>Abstract:</span>
                                            <p className="abstract__text">
                                                {item.abstract}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>
            </section>
        )
    }


}

const mapStateToProps = (state) => {
    return {
        citation: state.citation,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        fetchData: url => dispatch(citationFetchData(url)),
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(CitationInformation);

